import { render, staticRenderFns } from "./formPemenuhan14.vue?vue&type=template&id=d8385c60&"
import script from "./formPemenuhan14.vue?vue&type=script&lang=js&"
export * from "./formPemenuhan14.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports